import {IProjectStore} from "../index";
import {AnyAction} from "redux";
import {compose} from "lodash/fp";
import {mapAttr, mapId} from "./mutateAttributes";

const expandTable = ['Typ', 'Regulacja', 'Rodzaj', 'Opaska', 'Kąt łączenia', 'jambSize']

function checkCustom(custom, cond) {
  return Object.entries(cond).every(([key, val]) => custom[key] && custom[key].slug === val)
}

export default function (store: IProjectStore, action: AnyAction):IProjectStore {
  const attr = compose(
    filterById(store, action.attr),
  );

  const custom = attr();

  const selectedAttr = compose(
    mapId,
    selectOnChange(store, custom),
    mapAttr(store)
  )

  const sa = selectedAttr()

  let expanded:any = 'custom'

  if(checkCustom(custom, {
    type: "steel",
    regulation: "still"
  })) {
    expanded = 'jambColor'
  } else if(checkCustom(custom, {
    type: "steel",
    regulation: "regulable"
  })) {
    expanded = 'jambSize'
  } else if(checkCustom(custom, {
    type: 'mdf',
    regulation: 'still'
  })) {
    expanded = 'Z opaską'
  } else if(checkCustom(custom, {
    type: 'mdf',
    regulation: 'still',
    withBand: 'true'
  })) {
    expanded = 'jambColor'
  } else if(checkCustom(custom, {
    type: 'mdf',
    regulation: 'still',
    withBand: 'false'
  })) {
    expanded = 'jambColor'
  } else if(checkCustom(custom, {
    type: 'mdf',
    regulation: 'regulable',
    kind: 'reverse'
  })) {
    expanded = 'jambSize'
  }


  else {
    expanded = expandTable[expandTable.indexOf(store.expanded === 'custom'? expandTable[0] : store.expanded as any) + 1] || expanded
  }

  return {
    ...store,
    custom: custom,
    selectedAttributes: sa,
    expanded: expanded
  };
}

const selectOnChange = (store:IProjectStore, custom) => (selectedAttributes) => {
    if('type' in custom && 'regulation' in custom){
      if(custom.type.slug === 'steel'){
        if(custom.regulation.slug === 'still'){
          return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('stalowe') && a.name.toLowerCase().includes('stałe'))]
        } else {
          return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('stalowe') && !a.name.toLowerCase().includes('stałe'))]
        }
      } else {
        if(custom.regulation.slug === 'still' && 'withBand' in custom){
          return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('mdf') && a.name.toLowerCase().includes('stałe'))]
        } else {
            if('kind' in custom && custom.kind.slug === 'reverse'){
              return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('rewersyjne'))]
            } else {
              if('kind' in custom && 'band' in custom && 'angle' in custom){
                const angle = custom.angle.slug
                const band = custom.band.slug
                if(custom.kind.slug === 'non-rebated'){
                  return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('bezprzylgowe') && a.name.toLowerCase().includes(String(angle)) && a.name.toLowerCase().includes(String(band)))]
                } else {
                  return [...selectedAttributes.filter(a => a.category !== 'jamb'), store.attributes.find(a => a.name.toLowerCase().includes('przylgowe') && !a.name.toLowerCase().includes('bezprzylgowe') && a.name.toLowerCase().includes(String(angle)) && a.name.toLowerCase().includes(String(band)))]
                }
              }
            }
        }
      }
    }
    return selectedAttributes.filter(a => a.category !== 'jamb')
}

const filterById = (store, attr) => () => {
  return attr.id === 'type'? {[attr.id]: attr}:{...store.custom, [attr.id]: attr};
}